module.exports = __webpack_public_path__ + "img/supplier_1.8a2cf864.webp";